import { Button, CircularProgress } from "@mui/material";
import axios from "axios";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Form } from "react-router-dom";
import FormEKYC from "./FormEKYC";
import CryptoJS from "crypto-js";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";

const VerifyEKYC = (props) => {
  const {
    EKYC,
    productName,
    decryptedAcuvisor_product_id,
    decryptedResponseId,
    decryptedProductRef,
    quickQuoteDetails
  } = props;

  const [clickHereRef, setClickHereRef] = useState(false);
  const [seconds, setSeconds] = useState(10);
  const [timer,setTimer] = useState(false)

  const initialValues = {};
  console.log("product_name", productName);

  const onSubmit = (data) => {
    console.log("sub", data);
  };

  const careEKYC_handler = () => {
    console.log("clidedd EKYC");
    setClickHereRef("CLICKED");
    let encryptedProduct_ref = CryptoJS.AES.encrypt(
      JSON.stringify(decryptedProductRef),
      "secret key @123"
    ).toString();
    let e64_ProdRef = CryptoJS.enc.Base64.parse(encryptedProduct_ref);
    let encryptHexaProdRef = e64_ProdRef.toString(CryptoJS.enc.Hex);

    let encryptedDataId = CryptoJS.AES.encrypt(
      JSON.stringify(decryptedResponseId),
      "secret key @124"
    ).toString();
    let e64_Dataid = CryptoJS.enc.Base64.parse(encryptedDataId);
    let encryptHexaDataId = e64_Dataid.toString(CryptoJS.enc.Hex);

    let encryptedAcuvisor_product_id = CryptoJS.AES.encrypt(
      JSON.stringify(decryptedAcuvisor_product_id),
      "secret key @124"
    ).toString();

    let domain = "";

    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_FRONT_END;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_FRONT_END;
    } else {
      domain = process.env.REACT_APP_UAT_FRONT_END;
    }

    let returnURL = `${domain}/health-insurance/ekyc/${encryptHexaProdRef}*${encryptHexaDataId}`;

    console.log(
      encryptedProduct_ref,
      encryptHexaProdRef,
      encryptedDataId,
      encryptHexaDataId
    );
    console.log("retyu", String(returnURL));

    let reqBody = {
      getEdharDetailsIO: {
        task: "url",
        getEaadharessEntialsIO: {
          successRedirectUrl: returnURL,
          failureRedirectUrl: returnURL,
        },
      },
    };

     

    axiosInstance
      .post(
        `/api/health-insurance/care/ekyc/return-url/`,
        JSON.stringify(reqBody)
      )
      .then((resp) => {
        console.log("resp", resp);
        setClickHereRef('');
        window.open(`${resp.data.url}`);
      })
      .catch((e) => {
        setClickHereRef("FAILED");
setTimer(true)
          setTimeout(()=>{
            //setSeconds(seconds =>seconds - 1)
            
            setTimer(false)
            setClickHereRef('');

        },10000) 
      });
  };

  // const renderProductEKYC = () => {
  //     switch (productName) {
  //         case 33222:
  //             return careEKYC()
  //             break;
  //         case 33333:
  //             return careEKYC()
  //             break;
  //         case 'star':
  //             return starEKYC()
  //             break;
  //         default:

  //     }
  // }

  useEffect(() => {
    let interval = null
   /*  if (timer) {
        interval = setInterval(() => {
        setSeconds((prev) => prev -= 1);
        //setClickHereRef("");
      }, 1000);
    } else {
        clearInterval(interval)
    }  */
  }, [clickHereRef,seconds ]);

  console.log("aa", clickHereRef);
  const careEKYC = () => {
    return (
      <div>
        <div className="d-flex justify-content-center mt-4">
          <h3>Click on the button below to proceed EKYC</h3>
        </div>
        <div className="d-flex justify-content-center mt-4">
          {clickHereRef === "CLICKED" ? (
            <div className="d-flex justify-content-center">
              <CircularProgress />
            </div>
          ) : clickHereRef === "FAILED" ? (
            <div>
              <h2>Please try it after {seconds} sec</h2>
            </div>
          ) : (
            <Button onClick={careEKYC_handler}>Click Here</Button>
          )}
        </div>
      </div>
    );
  };

  // const starEKYC = () => {
  //     return (
  //         <>
  //             <FormEKYC />
  //         </>
  //     )
  // }

  return (
    <div>
      {EKYC && (
        <div className="form-container ">
          <div className="d-flex justify-content-center">
            <h3>EKYC Electronic Know Your Customer</h3>
          </div>

          {careEKYC()}
          {/*  {
                        productName === 'care' ?

                            <div className="d-flex justify-content-center mt-4">
                                <Button>
                                    Click Here
                                </Button>
                            </div>
                            : null

                    } */}
        </div>
      )}
    </div>
  );
};

export default VerifyEKYC;
